import { TYPE_PREJUDICE_LIBELLE, TYPE_PREJUDICE_OPTIONS } from './typePrejudice';

import i18n from '../i18n';
import { libellesTraduits } from '../i18n/libelles';

/**
 * Compatibilite entre le TYPE D'EXPERT et le TYPE DE PREJUDICE d'un reglement.
 *
 * POURQUOI CETTE REGLE EXISTE. Un expert medical evalue des atteintes a la
 * personne, un expert automobile evalue des degats sur un vehicule. Regler des
 * honoraires d'expert medical au titre d'un prejudice materiel n'est pas une
 * maladresse d'ecran : c'est une depense imputee sur un poste qui n'est pas le
 * sien, et elle se retrouve telle quelle dans les statistiques du sinistre.
 *
 * LE FORMULAIRE EMPECHE PLUTOT QU'IL NE CORRIGE. Les choix incompatibles sont
 * desactives, avec leur raison, au lieu d'etre refuses apres coup : un message
 * d'erreur apres validation oblige a deviner lequel des deux champs revoir.
 *
 * UN TYPE INCONNU N'INTERDIT RIEN. Si l'expert ne porte pas de type - donnee
 * ancienne, expert cree hors parcours - tout reste ouvert. Bloquer sur une
 * donnee absente empecherait de travailler sans rien garantir.
 */

/** Ce qu'un expert de chaque type peut legitimement faire evaluer. */
export const PREJUDICES_PAR_TYPE_EXPERT = {
    MEDICAL: ['CORPOREL', 'MORAL'],
    AUTOMOBILE: ['MATERIEL'],
};

// Adjectif accordé à « expert », lu dans la langue courante.

export const LIBELLE_TYPE_EXPERT = libellesTraduits('referentiels:compatibiliteExpert.typesExpert');

/** Les prejudices ouverts a ce type d'expert. `null` = aucune restriction. */
export function prejudicesAutorises(typeExpert) {
    return PREJUDICES_PAR_TYPE_EXPERT[typeExpert] || null;
}

/** Ce couple expert / prejudice tient-il debout ? */
export function estCompatible(typeExpert, typePrejudice) {
    const autorises = prejudicesAutorises(typeExpert);
    if (!autorises || !typePrejudice) return true;
    return autorises.includes(typePrejudice);
}

/**
 * Les options du selecteur de prejudice, les incompatibles desactivees.
 *
 * Elles restent VISIBLES et grisees plutot que retirees de la liste : une
 * option absente laisse chercher, une option grisee dit pourquoi elle l'est.
 */
export function optionsPrejudice(typeExpert) {
    const autorises = prejudicesAutorises(typeExpert);
    if (!autorises) return TYPE_PREJUDICE_OPTIONS;

    const raison = i18n.t('referentiels:compatibiliteExpert.typePrejudiceIncompatible', {
        type: LIBELLE_TYPE_EXPERT[typeExpert] || typeExpert,
    });

    return TYPE_PREJUDICE_OPTIONS.map((o) => (
        autorises.includes(o.value)
            ? o
            : { ...o, disabled: true, title: raison }
    ));
}

/**
 * Les options du selecteur d'expert, les incompatibles desactivees.
 *
 * La contrainte joue DANS LES DEUX SENS : choisir le prejudice en premier doit
 * fermer les experts qui ne peuvent pas l'evaluer, sinon l'utilisateur atteint
 * un couple interdit par l'autre bout du formulaire.
 */
export function optionsExpert(experts, typePrejudice, libelleDe) {
    return (experts || []).map((e) => {
        const compatible = estCompatible(e.expertTypeLabel, typePrejudice);
        return {
            value: e.expertTrackingId || e.trackingId,
            label: libelleDe(e),
            disabled: !compatible,
            title: compatible ? undefined
                : i18n.t('referentiels:compatibiliteExpert.expertIncompatible', {
                    type: LIBELLE_TYPE_EXPERT[e.expertTypeLabel] || e.expertTypeLabel,
                    prejudice: (TYPE_PREJUDICE_LIBELLE[typePrejudice]
                        ? i18n.t(`referentiels:typesPrejudice.${typePrejudice}`) : '').toLowerCase(),
                }),
        };
    });
}
